import * as React from "react";

const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    fill="none"
    viewBox="0 0 21 21"
  >
    <path
      fill="#FAAD14"
      d="M10.5 0C16.298 0 21 4.702 21 10.5S16.298 21 10.5 21 0 16.298 0 10.5 4.702 0 10.5 0m0 1.781A8.72 8.72 0 0 0 1.781 10.5a8.72 8.72 0 0 0 8.719 8.719 8.72 8.72 0 0 0 8.719-8.719A8.72 8.72 0 0 0 10.5 1.781m0 11.719a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m.563-8.25c.102 0 .187.085.187.188v6.375a.19.19 0 0 1-.187.187H9.937a.19.19 0 0 1-.187-.187V5.437c0-.103.084-.187.188-.187z"
    ></path>
  </svg>
);

export default WarningIcon;
